import { Box } from '@rocket/ui';
import { memo } from 'react';

import { insertTextPreviewStyles as styles } from './styles';

export interface ThresholdPreviewRowProps {
  id: string;
  text: string;
  score: number;
  positiveInsert?: boolean;
  insertText?: string;
  rejectText?: string;
}

const CheckCircleIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
  </svg>
);

const NotInterestedIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8 0-1.85.63-3.55 1.69-4.9L16.9 18.31A7.902 7.902 0 0 1 12 20zm6.31-3.1L7.1 5.69A7.902 7.902 0 0 1 12 4c4.42 0 8 3.58 8 8 0 1.85-.63 3.55-1.69 4.9z" />
  </svg>
);

const ThresholdPreviewRow = memo(
  ({
    id,
    text,
    score,
    positiveInsert = false,
    insertText = 'Your text would be inserted',
    rejectText = 'Your text would NOT be inserted',
  }: ThresholdPreviewRowProps) => (
    <tr id={id}>
      <Box as="td" css={styles.insertTextCell}>
        <span>{text}</span>
      </Box>
      <Box as="td" css={styles.insertScoreCell}>
        <span>{(score * 100).toFixed(2)}%</span>
      </Box>
      <td>
        <Box css={positiveInsert ? styles.insertTextGreen : styles.insertTextRed}>
          {positiveInsert ? <CheckCircleIcon /> : <NotInterestedIcon />}
          <span>{positiveInsert ? insertText : rejectText}</span>
        </Box>
      </td>
    </tr>
  )
);

ThresholdPreviewRow.displayName = 'ThresholdPreviewRow';

export default ThresholdPreviewRow;
